export default __webpack_public_path__ + "static/media/966H.afe2d94a.pdf";